export const ACCOUNT_TYPE_NAME = {
  agency: 'Агентство',
  developer: 'Застройщик',
  homeowner: 'Пользователь',
  management_company: 'Управляющая компания',
  rent_department: 'Отдел аренды',
  searcher: 'Пользователь',
  specialist: 'Риелтор',
  system: '',
  managementCompany: 'Управляющая компания',
  rentDepartment: 'Отдел аренды',
};
